import React from "react";
import { useTranslation } from "react-i18next";

function RulesSection() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const getTenderUrl = () => {
    if (currentLang === "zh") {
      return "/documents/第十八届世界精武武术锦标赛暨文化大会.pdf";
    }
    return "/documents/18th_World_Chin_Woo_Martial_Arts_Championship_&_Culture_Assembly.pdf";
  };

  const getTenderFileName = () => {
    if (currentLang === "zh") {
      return "第十八届世界精武武术锦标赛暨文化大会.pdf";
    }
    return "18th_World_Chin_Woo_Martial_Arts_Championship_&_Culture_Assembly.pdf";
  };

  const handleDownload = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="pt-12 pb-12 bg-white dark:bg-slate-800 transition-colors" id="rules-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-8 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("taolu_rules.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto">
          <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed mb-8 text-center">
            {t("taolu_rules.text")}
          </p>

          {/* Download Button */}
          <div className="flex justify-center">
            <button
              onClick={() => handleDownload(getTenderUrl(), getTenderFileName())}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary dark:bg-primary-light text-white text-base font-semibold rounded-lg border border-primary dark:border-primary-light transition-all duration-200 hover:bg-primary/90 dark:hover:bg-primary-light/90 hover:shadow-md"
            >
              <i className="fas fa-download"></i>
              {t("taolu_rules.download_tender")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RulesSection;

